<template>
  <div class="review-page-wrapper">
    <header class="header">
      <img src="../assets/tatusq.png" width="50" />
      <span>Tatu na Grota</span>
    </header>
    
    <main class="review-container" v-if="!loading">
      <div class="review-card">
        <h2>{{ 'Avalie seu Pedido' + (jaAvaliado ? '' : ' ⭐') }}</h2>
        
        <div v-if="jaAvaliado" class="success-message">
          <span class="material-icons-outlined icon-big" style="color: #FFD700;">star</span>
          <h3>Ops! Você já avaliou.</h3>
          <p>Identificamos que este pedido já possui uma avaliação registrada. Agradecemos muito pelo seu feedback!</p>
          <a href="#/" class="btn-voltar">Voltar para Loja</a>
        </div>
        
        <div v-else-if="enviado" class="success-message">
          <span class="material-icons-outlined icon-big">check_circle</span>
          <h3>Obrigado!</h3>
          <p>Sua avaliação foi enviada e será publicada em breve.</p>
          <a href="#/" class="btn-voltar">Voltar para Loja</a>
        </div>
        
        <div v-else>
          <p class="intro-text">Sua opinião é muito importante para nós!</p>
          <form @submit.prevent="enviarAvaliacao">
            <div class="stars-input">
              <span
                v-for="star in 5"
                :key="star"
                class="material-icons-outlined star"
                :class="{ active: star <= form.nota }"
                @click="setRating(star)"
              >
                {{ star <= form.nota ? 'star' : 'star_border' }}
              </span>
            </div>
            <p class="rating-label">{{ ratingLabel }}</p>
            
            <div class="form-group">
              <label>Seu Nome (como aparecerá no site)</label>
              <input v-model="form.nome_manual" type="text" class="input-tatu" placeholder="Ex: Maria José" required>
            </div>
            
            <div class="form-group">
              <label>Comentário</label>
              <textarea
                v-model="form.comentario"
                class="input-tatu textarea"
                placeholder="O que achou dos ovos? Chegaram bem?"
                rows="3"
              ></textarea>
            </div>
            
            <button type="submit" class="btn-submit" :disabled="loading || form.nota === 0">
              {{ loading ? 'Enviando...' : 'Enviar Avaliação' }}
            </button>
          </form>
        </div>
      </div>
    </main>
    
    <main v-else class="loading-overlay">
      <span class="material-icons-outlined spin">hourglass_top</span>
      <p>Verificando pedido...</p>
    </main>
  </div>
</template>

<script>
import api from '@/services/api';
import { AlertBus } from '@/plugins/AlertBus';

export default {
  name: "AvaliarPedido",
  data() {
    return {
      loading: true,
      enviado: false,
      jaAvaliado: false,
      form: {
        nota: 0,
        comentario: '',
        nome_manual: '',
        external_reference: ''
      }
    };
  },
  computed: {
    ratingLabel() {
      const labels = ["", "Ruim", "Razoável", "Bom", "Muito Bom", "Excelente!"];
      return labels[this.form.nota];
    }
  },
  async mounted() {
    // Pega a referencia da URL: #/avaliar?ref=XYZ
    // Usa window.location.hash para compatibilidade com o modo hash do Vue Router manual
    const hashPart = window.location.hash.split('?')[1];
    const urlParams = new URLSearchParams(hashPart);
    const ref = urlParams.get('ref');
    
    if (!ref) {
      AlertBus.$emit('show-alert', { message: 'Link inválido.', type: 'erro' });
      setTimeout(() => window.location.hash = '#/', 3000);
      this.loading = false;
    } else {
      this.form.external_reference = ref;
      await this.verificarSeJaAvaliou(ref);
    }
  },
  methods: {
    setRating(star) {
      this.form.nota = star;
    },
    async enviarAvaliacao() {
      if (this.form.nota === 0) return;
      
      this.loading = true;
      try {
        await api.post('/api/avaliacoes', this.form);
        this.enviado = true;
        AlertBus.$emit('show-alert', { message: 'Avaliação enviada com sucesso!', type: 'success' });
      } catch (err) {
        const msg = err.response?.data?.error || 'Erro ao enviar.';
        AlertBus.$emit('show-alert', { message: msg, type: 'erro' });
      } finally {
        this.loading = false;
      }
    },
    async verificarSeJaAvaliou(ref) {
      this.loading = true;
      try {
        const res = await api.get(`/api/avaliacoes/check/${ref}`);
        if (res.data.avaliado) {
          this.jaAvaliado = true;
        }
      } catch (err) {
        console.error("Erro ao verificar histórico de avaliação.", err);
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>

<style scoped>
/* 1. RESET BÁSICO (CRUCIAL):
   Iguala o comportamento de margens e box-sizing ao da página Comprar.vue.
   Isso corrige a altura e posição do header. */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.review-page-wrapper {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  
  /* 2. FONTE E LINHA PADRONIZADAS:
     Copiado exatamente de Comprar.vue para garantir identidade visual. */
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  line-height: 1.6;
  
  background-color: var(--bg-main);
  color: var(--text-main);
}

/* Header (Idêntico ao Comprar.vue) */
.header {
  padding: 5px;
  text-align: center;
  background-color: var(--bg-header);
  border-bottom: 1px solid var(--border-light);
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--color-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.review-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  animation: fadeIn 0.3s ease-out;
}

.review-card {
  background: var(--bg-card);
  padding: 30px;
  border-radius: 10px;
  width: 100%;
  max-width: 500px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  border: 1px solid var(--border-light);
}

.intro-text {
  color: var(--text-secondary);
  margin-bottom: 20px;
}

/* Estrelas */
.stars-input {
  display: flex;
  justify-content: center;
  gap: 5px;
  cursor: pointer;
}
.star {
  font-size: 40px;
  color: var(--text-secondary);
  transition: transform 0.2s;
}
.star.active {
  color: #FFD700;
  fill: #FFD700;
  transform: scale(1.1);
}
.rating-label {
  height: 20px;
  color: var(--color-accent);
  font-weight: bold;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
  text-align: left;
}
.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 0.9rem;
  color: var(--text-secondary); /* Adicionado para consistência */
}
.input-tatu {
  width: 100%;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid var(--border-light);
  background: var(--bg-main);
  color: var(--text-main);
  font-size: 1rem; /* Tamanho de fonte padronizado */
}
.input-tatu:focus {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: 0 0 0 2px rgba(var(--color-accent), 0.2);
}

.btn-submit {
  width: 100%;
  padding: 15px;
  background: var(--color-button-buy);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  font-size: 1.1rem;
  cursor: pointer;
  margin-top: 10px;
  transition: transform 0.1s;
}
.btn-submit:hover:not(:disabled) {
  background-color: var(--color-button-buy-hover-bg);
}
.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}
.icon-big {
  font-size: 60px;
  color: #4CAF50;
}
.btn-voltar {
  margin-top: 20px;
  display: inline-block;
  padding: 10px 20px;
  background: var(--bg-main);
  border: 1px solid var(--border-light);
  color: var(--text-main);
  text-decoration: none;
  border-radius: 6px;
  font-weight: bold;
}

/* Loading Styles */
.loading-overlay {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  color: var(--text-secondary);
  font-size: 1.2rem;
}
.spin {
  font-size: 48px;
  margin-bottom: 15px;
  animation: spin 1s linear infinite;
  color: var(--color-accent);
}

@keyframes spin { 100% { transform: rotate(360deg); } }
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
</style>